import { prefix } from '@/constant';
import request from '@/utils/request';

/**
 * 文件流返回
 * @param url 接口地址
 */

export const downloadData = (condition: any): Promise<any> => {
  return request({
    url: '/file/platformFile/download',
    data: condition,
  });
};

export const smsSendVerify = (params: { mobile: string; scene: string }) => {
  return request({
    url: prefix + '/common/smsSendVerify',
    method: 'post',
    params,
  });
};

export const downloadDataWithUrl = (
  url: string,
  condition: any,
): Promise<any> => {
  return request({
    url: url,
    data: condition,
  });
};

// 根据keys 逗号分割，得到列表
export const getConfigKeys = (configKeys: string) => {
  return request({
    url: '/system/config/openConfigKeys',
    params: { configKeys },
  });
};

// 文件上传统一接口
export const uploadApi =
  import.meta.env.VITE_APP_BASE_API + '/commonfile/upload';

export const previewApi =
  import.meta.env.VITE_APP_BASE_API + '/commonfile/preview';

export const getAiTicket = (): Promise<IResponse> => {
  return request({
    url: '/ai/ticket',
    method: 'get',
  });
};
